module.exports = __webpack_public_path__ + "img/orange_027.ec7cdb04.png";